import {Flex, Text, Button, Heading, Image} from '@chakra-ui/react';
import {useState, useEffect} from 'react';
import axios from 'axios';

const DogIpsum = ({factURL}) => {
  const [visible, setVisible] = useState(false);
  const [dogFact, setDogFact] = useState();

  // CORS bridge required for external api, because it doesn't set CORS headers
  useEffect(() => {
    const fetchDogFact = async () => {
      await axios
        .get(
          factURL
            ? factURL
            : 'https://cors.bridged.cc/https://dog-facts-api.herokuapp.com/api/v1/resources/dogs?index=' +
                Math.floor(Math.random() * 423),
          {headers: {'X-Requested-With': 'XmlHttpRequest'}},
        )
        .then(res => {
          setDogFact(res.data[0].fact);
          return res.data[0].fact;
        })
        .catch(error => error);
    };
    fetchDogFact();
  }, [factURL]);

  return (
    <Flex direction="column" align="center">
      <Heading>Dog Ipsum</Heading>
      <Text lineHeight="5%">
        Doggo ipsum sub woofer porgo mlem. Long woofer shibe long woofer boofers
        pupper borkf puggorino, shoob pupper fat boi doing me a frighten puggo.
        Boofers shibe stop it fren clouds, shoob wrinkler boof adorable doggo,
        doggorino vvv. Waggy wags shooberino heckin angery woofer what a nice
        floof adorable doggo, ur givin me a spook wow such tempt doing me a
        frighten, boof boofers long doggo. ur givin me a spook wow such tempt.
        Pats puggorino puggo blep, maximum borkdrive. Shoob porgo tungg, such
        treat. Pupperino heckin angery woofer I am bekom fat big ol you are doin
        me a concern, stop it fren borking doggo. You are doin me a concern
        length boy aqua doggo the neighborhood pupper boof long woofer, he made
        many woofs puggo smol aqua doggo, long doggo big ol shibe heckin. Big ol
        wow such tempt long doggo ur givin me a spook smol borking doggo with a
        long snoot for pats doggo borkf heckin angery woofer, long bois noodle
        horse sub woofer snoot thicc.
      </Text>
      <Text lineHeight="5%">
        You are doing me a frighten clouds puggorino big ol pupper adorable
        doggo, much ruin diet maximum borkdrive boof. Wow such tempt blop very
        good spot shoober long doggo, wow very biscit heckin good boys.
        Borkdrive pupperino shoober sub woofer h*ck heckin angery woofer, noodle
        horse heckin what a nice floof fat boi. H*ck porgo he made many woofs
        very taste wow, what a nice floof. Heckin long woofer clouds, blep.
        Heckin good boys and girls doggorino fat boi such treat big ol thicc,
        stop it fren borking doggo most angery pupper I have ever seen. Mlem ur
        givin me a spook heckin good boys and girls doge, thicc heckin good boys
        and girls.
      </Text>
      <Text lineHeight="5%">
        Big ol pupper puggo what a nice floof doge yapper, boof mlem maximum
        borkdrive, heckin angery woofer blep smol borking doggo with a long
        snoot for pats. Shoober lotsa pats heckin borking doggo, smol borking
        doggo with a long snoot for pats noodle horse blop, dat tungg tho
        borking doggo. Extremely cuuuuuute you are doing me a frighten puggorino
        thicc super chub, pupperino very hand that feed shibe pupper woofer stop
        it fren, clouds shoob fluffer. Shoober fluffer thicc doggorino
        shooberino stop it fren heckin good boys and girls clouds, wrinkler
        floofs aqua doggo you are doin me a concern puggo. Stop it fren
        extremely cuuuuuute he made many woofs wrinkler long woofer, ur givin me
        a spook adorable doggo clouds. Tungg shibe heckin good boys porgo I am
        bekom fat big ol pupper super chub, aqua doggo bork long doggo heck.
        corgo porgo. Waggy wags fluffer noodle horse, you are doing me the
        shock.
      </Text>
      <Text lineHeight="5%">
        Stop it fren very taste wow wrinkler adorable doggo wow such tempt,
        clouds doggo corgo. Woofer aqua doggo you are doing me a frighten much
        ruin diet blep lotsa pats heckin good boys and girls, vvv h*ck smol most
        angery pupper I have ever seen. Wow such tempt pupperino heckin good
        boys and girls you are doing me a frighten such treat the neighborhood
        pupper shoob snoot, very jealous pupper puggo stop it fren wow very
        biscit heck. Heck long woofer shoober snoot length boy fluffer, boofers
        shooberino snoot. Vvv heckin ur givin me a spook ruff adorable doggo,
        woofer most angery pupper I have ever seen waggy wags snoot, very taste
        wow long water shoob noodle horse. Heck stop it fren h*ck, length boy.
        Big ol pupper much ruin diet extremely cuuuuuute the neighborhood pupper
        yapper, puggorino doggorino ur givin me a spook most angery pupper I
        have ever seen, pats yapper ruff. Wow very biscit doggo I am bekom fat
        stop it fren, pupperino ur givin me a spook.
      </Text>
      <Text lineHeight="5%">
        Much ruin diet long woofer porgo shooberino fat boi wow very biscit
        doggorino, shoob heckin he made many woofs blop. Pupperino much ruin
        diet noodle horse very hand that feed shibe thicc heck pats, pupper
        porgo doggo bork. Doing me a frighten what a nice floof doge sub woofer
        porgo doge sub woofer yapper, wrinkler lotsa pats big ol heckin good
        boys and girls shoob.
      </Text>
      <Text lineHeight="5%">
        Such treat most angery pupper I have ever seen sub woofer, the
        neighborhood pupper. Snoot puggorino extremely cuuuuuute very good spot,
        ur givin me a spook maximum borkdrive shoober, pupper borkdrive. Maximum
        borkdrive very hand that feed shibe very good spot most angery pupper I
        have ever seen big ol smol borking doggo with a long snoot for pats
        ruff, blep heckin angery woofer big ol pupper he made many woofs. Yapper
        pupperino length boy borking doggo, h*ck. Snoot boof wow such tempt
        doggorino, dat tungg tho extremely cuuuuuute very taste wow long bois,
        big ol pupper most angery pupper I have ever seen. Shoob lotsa pats
        tungg h*ck, big ol. Borking doggo lotsa pats blop, big ol pupper. Doing
        me a frighten doggorino smol thicc ruff maximum borkdrive big ol pupper,
        porgo length boy maximum borkdrive heckin good boys and girls length
        boy.
      </Text>
      <Text lineHeight="5%">
        Smol doggorino boofers extremely cuuuuuute porgo, blop smol borking
        doggo with a long snoot for pats wow such tempt. Puggorino mlem tungg
        ruff, fat boi. Bork you are doin me a concern pupperino puggo maximum
        borkdrive h*ck much ruin diet, big ol porgo lotsa pats doge. very good
        spot dat tungg tho heckin. Fat boi heckin good boys and girls wow very
        biscit heck pats, very jealous pupper heckin. Shoober fat boi ur givin
        me a spook many pats boof wrinkler, ruff tungg heckin good boys. Very
        taste wow snoot doggorino heck, wow very biscit snoot. Heck smol doing
        me a frighten mlem, doggorino most angery pupper I have ever seen. You
        are doing me a frighten corgo borkdrive doggorino heck yapper, you are
        doing me the shock long water shoob aqua doggo wow very biscit very good
        spot, shoob shoober you are doin me a concern very good spot. Fat boi
        you are doing me a frighten heckin angery woofer borkf tungg, long
        woofer snoot many pats.
      </Text>
      <Image
        alt="Dog being scared"
        src="https://media.giphy.com/media/51Uiuy5QBZNkoF3b2Z/giphy.gif"
        width="clamp(200px, 50%, 600px)"
      ></Image>
      <Button m="5" onClick={() => setVisible(!visible)}>
        Random Dog Fact
      </Button>
      {visible && <Text>Your Dog Fact: {dogFact}</Text>}
    </Flex>
  );
};

export default DogIpsum;
